import { EXT_URL, T_NUMBER } from './setting-values';
import { Environment } from './Type';

export const environmentDefault: Environment = {
  debug: true,
  production: false,
  devtoolsEnabled: 'true',

  home: `http://local.mo2-care${T_NUMBER ? `-t${T_NUMBER}` : ''}.ext.apc-dev02.azure.to2cz.cz/`,

  buildProperties: {
    bffAuthUrl: `https://${EXT_URL}/api/auth`,
    adobeLaunchPath:
      'https://assets.adobedtm.com/b8db4c46addb/d1bcba65d545/launch-EN96a86e39b45c4bc68439f1ac54e7990b-staging.min.js',
    backlinkCookieLastVisitedPageDomain: '.to2cz.cz',
    guiGeneralPlannedOutageUrl: 'https://www.o2.cz/osobni/odstavka_mojeo2/',
    apiRequestTimeoutInSec: '30',
  },
  propertyUrl: `https://${EXT_URL}/api/bffgw${T_NUMBER ? `-t${T_NUMBER}-` : '-'}property`,
  propertyTTL: 18000000,

  appTranslation: {
    translateRootKey: 'mo2-crmServices',
    defaultLocale: 'cs',
    defaultNamespace: 'oneCRM',
    supportedLocales: ['en', 'cs'],
  },

  apiGenerator: {
    // the value should also correspond with package.json (see command 'generate-api') and .gitignore file
    targetDirectory: './src/models/swagger-gen',
    localFilesSourceDir: './swagger-api',
  },

  urlConfig: {
    translate: {
      propertyKey: 'global.url.cms.langtexts',
    },
    kahl: {
      propertyKey: 'bff.kahl.url',
    },
    journaling: {
      propertyKey: 'bff.journaling.url',
    },
    documents: {
      propertyKey: 'bff.documents.url',
    },
    customer: {
      propertyKey: 'bff.customer.url',
    },
    externalUserAccesses: {
      propertyKey: 'bff.user.url',
    },
    internalUser: {
      propertyKey: 'bff.internaluser.url',
    },
    codebook: {
      propertyKey: 'bff.codebook.url',
    },
    userAccess: {
      propertyKey: 'bff.useraccess.url',
    },
    userContext: {
      propertyKey: 'bff.usercontext.url',
    },
    customerAccount: {
      propertyKey: 'bff.customeraccount.url',
    },
    tariffSpace: {
      propertyKey: 'bff.tariffspace.url',
    },
    asset: {
      propertyKey: 'bff.asset.url',
    },
    sharedObjects: {
      propertyKey: 'bff.sharedobjects.url',
    },
    mock: {
      // DEPRECATED
      propertyKey: 'bff.mock.url',
    },
    user: {
      propertyKey: 'bff.user.url',
    },
    userMgw: {
      propertyKey: 'bff.user-mgw.url',
    },
    oneportalDeeplinker: {
      propertyKey: 'oneportal.deeplinker.url',
    },
    pzForIframeApf2: {
      propertyKey: 'onecrm.pzForIframeApf2.url',
    },
    pzForIframeApf2CreateCr: {
      propertyKey: 'onecrm.pzForIframeApf2.createCr.url',
    },
    billingManagement: {
      propertyKey: 'bff.billingmanagement.url',
    },
    offer: {
      propertyKey: 'bff.offer.url',
    },
    financialInfo: {
      propertyKey: 'bff.financial-info.url',
    },
    notifyEvent: {
      propertyKey: 'bff.notifyevent.url',
    },
    crmfin: {
      propertyKey: 'bff.crmfin.url',
    },
    eBillDownloader: {
      propertyKey: 'BSLEBILL.url.downloadBaseUrl',
    },
    paymentGateway: {
      propertyKey: 'bff.paymentgateway.url',
    },
    crm: {
      propertyKey: 'bff.crm.url',
    },
    invoices: {
      propertyKey: 'bff.invoices.url',
    },
  },

  translate: {},
  properties: {},
};
